module.exports = __webpack_public_path__ + "static/media/favorite.f62966fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/games/favorite.png
// module id = 823
// module chunks = 7